import React from 'react';

function Shipping() {
  return (
    <div className="flex my-[50px] justify-center">
      <div className="w-[900px] h-[700px] p-16 overflow-auto shadow-xl">
        <h1 className="text-[#003478]  font-extrabold text-2xl text-center ">
          {' '}
          Shipping & Delivery Policy
        </h1>
        <hr className="my-8 h-1 " />

        <p>
          For any insurance product purchased via www.insureefficient.com, a
          soft copy of the policy will be emailed to the email id provided at
          the time of buying the product. The soft copy will be emailed to you
          by EFFICIENT, the insurance provider /company or both. <br /> <br />
          The Insurance Company will also courier a hard copy of the policy
          documents, within 15-21 days of buying the insurance policy.
        </p>
      </div>
    </div>
  );
}

export default Shipping;
